// /Frontend/hoppla-admin/src/features/auth/AdminAuthGuard.tsx

import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAdminAuth } from './auth-context';

interface AdminAuthGuardProps {
  children?: ReactNode;
}

export function AdminAuthGuard({ children }: AdminAuthGuardProps): JSX.Element {
  const location = useLocation();
  const { isAuthenticated, isBootstrapping } = useAdminAuth();

  if (isBootstrapping) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          background: '#f8fafc',
          color: '#1e3a5f',
          fontSize: '1rem',
        }}
      >
        Chargement de la session admin…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (children) {
    return <>{children}</>;
  }

  return <Outlet />;
}

export default AdminAuthGuard;
